import { apiAxiosAuth } from 'services/api';
import { GetProductByCollectionOrQueryResp } from 'types/GetProductByCollectionOrQueryResp';

function returnQuery(productToSearch: string) {
	return `bridge/vtex/api/io/_v/api/intelligent-search/product_search/trade-policy/1/${productToSearch}`;
	// return `bridge/vtex/api/io/_v/api/intelligent-search/product_search?q=product:${productToSearch}&seller=mdlzbrqatestingdist5`;
}

export async function getProductByCollectionOrQuery(
	productToSearch: string,
	handleNotify: any
) {
	const resp: GetProductByCollectionOrQueryResp = {
		isSuccess: false,
		products: [],
		qtdAllProducts: 0
	};

	await apiAxiosAuth
		.get(`${returnQuery(productToSearch)}`)
		.then((response) => {
			resp.products = response?.data?.products || [];
			resp.isSuccess = true;
			resp.qtdAllProducts = response?.data?.recordsFiltered || 0;
		})
		.catch((error) => {
			handleNotify(error?.message || '', 'error');
			resp.products = [];
			resp.isSuccess = false;
			resp.qtdAllProducts = 0;
		});

	return resp;
}
